import { IconProps } from './IconProps';

export const ProLiquidGlass = ({ className, style }: IconProps) => {
  return (
    <svg
      className={className}
      style={style}
      width="49"
      height="29"
      viewBox="0 0 49 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_i_1951_660)">
        <rect
          y="0.594727"
          width="49"
          height="27.8108"
          rx="13.9054"
          fill="url(#paint0_linear_1951_660)"
          fill-opacity="0.02"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_i_1951_660)">
        <rect
          width="49"
          height="27.8108"
          rx="13.9054"
          transform="matrix(1 0 0 -1 0 28.4058)"
          fill="url(#paint1_linear_1951_660)"
          fill-opacity="0.02"
        />
      </g>
      <g opacity="0.5" filter="url(#filter2_i_1951_660)">
        <rect
          y="1.38965"
          width="49"
          height="26.2216"
          rx="13.1108"
          fill="white"
          fill-opacity="0.01"
        />
      </g>
      <g opacity="0.5" filter="url(#filter3_i_1951_660)">
        <mask id="path-4-inside-1_1951_660" fill="white">
          <path d="M0 14.5001C0 6.82039 6.22566 0.594727 13.9054 0.594727H35.0946C42.7743 0.594727 49 6.82039 49 14.5001V14.5001C49 22.1799 42.7743 28.4055 35.0946 28.4055H13.9054C6.22566 28.4055 0 22.1799 0 14.5001V14.5001Z" />
        </mask>
        <path
          d="M0 14.5001C0 6.52783 6.46283 0.0649968 14.4351 0.0649968H34.5649C42.5372 0.0649968 49 6.52783 49 14.5001V14.5001C49 7.11295 42.7743 1.12446 35.0946 1.12446H13.9054C6.22566 1.12446 0 7.11295 0 14.5001V14.5001ZM49 28.4055H0H49ZM0 28.4055V0.594727V28.4055ZM49 0.594727V28.4055V0.594727Z"
          fill="url(#paint2_linear_1951_660)"
          mask="url(#path-4-inside-1_1951_660)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter4_i_1951_660)">
        <mask id="path-6-inside-2_1951_660" fill="white">
          <path d="M0 14.5004C0 22.1801 6.22566 28.4058 13.9054 28.4058H35.0946C42.7743 28.4058 49 22.1801 49 14.5004V14.5004C49 6.82061 42.7743 0.59495 35.0946 0.59495H13.9054C6.22566 0.59495 0 6.82061 0 14.5004V14.5004Z" />
        </mask>
        <path
          d="M0 14.5004C0 22.4727 6.46283 28.9355 14.4351 28.9355H34.5649C42.5372 28.9355 49 22.4727 49 14.5004V14.5004C49 21.8875 42.7743 27.876 35.0946 27.876H13.9054C6.22566 27.876 0 21.8875 0 14.5004V14.5004ZM49 0.59495H0H49ZM0 0.59495V28.4058V0.59495ZM49 28.4058V0.59495V28.4058Z"
          fill="url(#paint3_linear_1951_660)"
          mask="url(#path-6-inside-2_1951_660)"
        />
      </g>
      <g filter="url(#filter5_d_1951_660)">
        <g filter="url(#filter6_i_1951_660)">
          <path
            d="M35.6869 20.7088C34.4988 20.7088 33.476 20.451 32.6185 19.9354C31.7667 19.4142 31.1082 18.6772 30.643 17.7245C30.1779 16.7718 29.9453 15.6453 29.9453 14.3452V14.3283C29.9453 13.0226 30.1779 11.8961 30.643 10.949C31.1138 9.99627 31.7779 9.26212 32.6353 8.74653C33.4984 8.23094 34.5156 7.97314 35.6869 7.97314C36.8637 7.97314 37.8809 8.23094 38.7384 8.74653C39.5958 9.26212 40.2571 9.99627 40.7223 10.949C41.1874 11.9017 41.42 13.0282 41.42 14.3283V14.3452C41.42 15.6453 41.1874 16.7718 40.7223 17.7245C40.2627 18.6772 39.6042 19.4142 38.7468 19.9354C37.8893 20.451 36.8693 20.7088 35.6869 20.7088ZM35.6869 18.8342C36.4098 18.8342 37.0347 18.6492 37.5615 18.2793C38.0883 17.9095 38.4946 17.3883 38.7804 16.7158C39.0718 16.0432 39.2175 15.253 39.2175 14.3452V14.3283C39.2175 13.4149 39.0718 12.6247 38.7804 11.9578C38.4946 11.2852 38.0883 10.7669 37.5615 10.4026C37.0347 10.0327 36.4098 9.84776 35.6869 9.84776C34.9695 9.84776 34.3446 10.0327 33.8122 10.4026C33.2854 10.7669 32.8763 11.2852 32.5849 11.9578C32.2991 12.6247 32.1562 13.4149 32.1562 14.3283V14.3452C32.1562 15.253 32.2963 16.0432 32.5765 16.7158C32.8623 17.3883 33.2686 17.9095 33.7954 18.2793C34.3278 18.6492 34.9583 18.8342 35.6869 18.8342Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter7_i_1951_660)">
          <path
            d="M19.6172 20.4058V8.27539H24.5181C25.3867 8.27539 26.1321 8.42951 26.7542 8.73774C27.3763 9.04597 27.8526 9.4803 28.1833 10.0407C28.5139 10.6011 28.6792 11.2681 28.6792 12.0414V12.0583C28.6792 12.8597 28.4775 13.5714 28.074 14.1935C27.6761 14.8099 27.1185 15.2471 26.4011 15.5049L29.0491 20.4058H26.5777L24.1902 15.8411C24.179 15.8411 24.1622 15.8411 24.1398 15.8411C24.1174 15.8411 24.0978 15.8411 24.081 15.8411H21.786V20.4058H19.6172ZM21.786 14.1767H24.2911C24.9804 14.1767 25.5156 13.9945 25.8967 13.6302C26.2778 13.266 26.4684 12.7588 26.4684 12.1087V12.0919C26.4684 11.4586 26.2694 10.957 25.8715 10.5871C25.4792 10.2117 24.9384 10.0239 24.2491 10.0239H21.786V14.1767Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter8_i_1951_660)">
          <path
            d="M10.186 16.3959V14.6474H13.414C14.193 14.6474 14.7983 14.4485 15.2298 14.0506C15.6613 13.6471 15.8771 13.081 15.8771 12.3525V12.3357C15.8771 11.6015 15.6613 11.0355 15.2298 10.6376C14.7983 10.2397 14.193 10.0407 13.414 10.0407H10.186V8.27539H13.9436C14.7674 8.27539 15.4876 8.44352 16.1041 8.77977C16.7205 9.11603 17.2025 9.58958 17.55 10.2004C17.8974 10.8057 18.0711 11.5146 18.0711 12.3273V12.3441C18.0711 13.1511 17.8974 13.86 17.55 14.4709C17.2025 15.0761 16.7205 15.5497 16.1041 15.8915C15.4876 16.2278 14.7674 16.3959 13.9436 16.3959H10.186ZM9.10156 20.4058V8.27539H11.2704V20.4058H9.10156Z"
            fill="white"
          />
        </g>
      </g>
      <g clip-path="url(#clip0_1951_660)">
        <foreignObject x="-1.98649" y="-1.39176" width="52.973" height="31.784">
          <div
            // xmlns="http://www.w3.org/1999/xhtml"
            style={{
              //   backdropFilter: 'blur(0.99px)',
              clipPath: 'url(#bgblur_1_1951_660_clip_path)',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="1.98649"
          y="0.594727"
          width="49"
          height="27.8108"
          rx="13.9054"
          fill="white"
          fill-opacity="0.01"
        />
      </g>
      <g clip-path="url(#clip2_1951_660)">
        <foreignObject x="-1.98649" y="-1.39176" width="52.973" height="31.784">
          <div
            // xmlns="http://www.w3.org/1999/xhtml"
            style={{
              //   backdropFilter: 'blur(0.99px)',
              clipPath: 'url(#bgblur_3_1951_660_clip_path)',
              height: '100%',
              width: '100%',
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="1.98649"
          width="49"
          height="27.8108"
          rx="13.9054"
          transform="matrix(-1 0 0 1 49 0.594727)"
          fill="white"
          fill-opacity="0.01"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_1951_660"
          x="0"
          y="0.594727"
          width="49"
          height="31.784"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.97297" />
          <feGaussianBlur stdDeviation="3.97297" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter1_i_1951_660"
          x="0"
          y="-3.37825"
          width="49"
          height="31.784"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-3.97297" />
          <feGaussianBlur stdDeviation="3.97297" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter2_i_1951_660"
          x="0"
          y="1.38965"
          width="49"
          height="26.2217"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.11892" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter3_i_1951_660"
          x="0"
          y="0.594727"
          width="49"
          height="27.811"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.11892" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter4_i_1951_660"
          x="0"
          y="0.594727"
          width="49"
          height="27.811"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.11892" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter5_d_1951_660"
          x="3.80427"
          y="2.67585"
          width="42.9149"
          height="23.3304"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.64865" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1951_660"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1951_660"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_i_1951_660"
          x="29.9453"
          y="7.97314"
          width="11.4766"
          height="14.0602"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.32432" />
          <feGaussianBlur stdDeviation="1.32432" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter7_i_1951_660"
          x="19.6172"
          y="8.27539"
          width="9.42969"
          height="13.4547"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.32432" />
          <feGaussianBlur stdDeviation="1.32432" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <filter
          id="filter8_i_1951_660"
          x="9.10156"
          y="8.27539"
          width="8.96875"
          height="13.4547"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.32432" />
          <feGaussianBlur stdDeviation="1.32432" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1951_660"
          />
        </filter>
        <clipPath
          id="bgblur_1_1951_660_clip_path"
          transform="translate(1.98649 1.39176)"
        >
          <rect y="0.594727" width="49" height="27.8108" rx="13.9054" />
        </clipPath>
        <clipPath
          id="bgblur_3_1951_660_clip_path"
          transform="translate(1.98649 1.39176)"
        >
          <rect
            width="49"
            height="27.8108"
            rx="13.9054"
            transform="matrix(-1 0 0 1 49 0.594727)"
          />
        </clipPath>
        <linearGradient
          id="paint0_linear_1951_660"
          x1="24.5"
          y1="0.594727"
          x2="24.5"
          y2="28.4055"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1951_660"
          x1="24.5"
          y1="0"
          x2="24.5"
          y2="27.8108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1951_660"
          x1="24.5"
          y1="0.594727"
          x2="24.5"
          y2="1.91905"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C3C3C3" />
          <stop offset="1" stop-color="#F9F9F9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1951_660"
          x1="24.5"
          y1="28.4058"
          x2="24.5"
          y2="27.0814"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C3C3C3" />
          <stop offset="1" stop-color="#F9F9F9" />
        </linearGradient>
        <clipPath id="clip0_1951_660">
          <rect
            width="25.1622"
            height="27.8108"
            fill="white"
            transform="translate(0 0.594727)"
          />
        </clipPath>
        <clipPath id="clip2_1951_660">
          <rect
            width="23.8378"
            height="27.8108"
            fill="white"
            transform="translate(25.1641 0.594727)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
